import { LAUNCH_DARKLY_FLAGS } from 'common/launchDarklyFlags';
import { setCcToEcRedirectEnabled, setCcToEcRedirectLoaderHandler } from 'helpers/ccToEcRedirect';
import { useFeatureFlags } from 'hooks/useFeatureFlags';
import { type FC, useEffect } from 'react';
import { useFullscreenLoader } from 'store/features/UI';

/**
 * Renderless component that mirrors the `cc-to-ec-page-redirects` LaunchDarkly flag into the
 * module state the axios layer reads, and lends it the fullscreen loader for the moment between a
 * 470 response and the navigation it triggers.
 *
 * Must be placed inside the LaunchDarkly provider.
 */
const CcToEcRedirectFlagSync: FC = () => {
  const [isRedirectFlagEnabled] = useFeatureFlags([
    { flagKey: LAUNCH_DARKLY_FLAGS['cc-to-ec-page-redirects'], defaultValue: false },
  ]);
  const isRedirectEnabled = Boolean(isRedirectFlagEnabled);
  const { setFullscreenLoading } = useFullscreenLoader();

  useEffect(() => {
    setCcToEcRedirectEnabled(isRedirectEnabled);
  }, [isRedirectEnabled]);

  useEffect(() => {
    setCcToEcRedirectLoaderHandler(() => setFullscreenLoading(true));

    return () => setCcToEcRedirectLoaderHandler(null);
  }, [setFullscreenLoading]);

  return null;
};

export default CcToEcRedirectFlagSync;
